import React from "react";
import { keyframes } from "@mui/system";
import { formatPacific } from "../../utils/pacificTime";

export const gradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const appBackgroundGradient =
  "linear-gradient(90deg, #1E142B, #2C1D3D, #1B0D36, #170730)";

// Vancouver calendar date ("Nov 20, 2026"), identical on every device.
// Empty input renders nothing: formatPacific(undefined) would be today.
export const formatDateToLocalAmericaPacific = (date) => {
  if (date === null || date === undefined || date === "") return "";
  return formatPacific(date, "MMM D, YYYY");
};

export const generateUniqueInvoiceNumber = (date) => {
  const formattedDate = formatPacific(date, "MM/DD/YY");
  return `CNT-INV-${formattedDate}`;
};
export const generateUniqueDepositNumber = (date) => {
  const formattedDate = formatPacific(date, "MM/DD/YY");
  return `BLL-${formattedDate}`;
};

export const generateUniqueFinalNumber = (date) => {
  const formattedDate = formatPacific(date, "MM/DD/YY");
  return `FNL-BLL-${formattedDate}`;
};

export const generateUniqueReceiptNumber = (date) => {
  const formattedDate = formatPacific(date, "MM/DD/YY");
  return `FNL-RCPT-${formattedDate}`;
};

// Extracts "City, Province/Country" from a full address string.
// If the address does not contain at least two comma-separated parts, returns the original address.
export const getCityProvince = (address) => {
  if (!address || typeof address !== "string") return "";
  const parts = address
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length < 2) return address;

  const city = parts[parts.length - 2];
  let provinceRaw = parts[parts.length - 1];
  // Remove postal/zip codes and keep first token (e.g., 'BC' from 'BC V0N 1V7')
  provinceRaw = provinceRaw.replace(/\d+/g, "").trim();
  const province = provinceRaw.split(/\s+/)[0];

  return `${city}, ${province}`;
};

export const generateUniqueDepositReceiptNumber = (date) => {
  const formattedDate = formatPacific(date, "MM/DD/YY");
  return `DPT-RCPT-${formattedDate}`;
};

export const generateUniqueFileName = (title, date, fileFormat) => {
  const sanitizedFileName = `${title} at ${formatDateToLocalAmericaPacific(
    date
  )} ${fileFormat} ${formatDateToLocalAmericaPacific(new Date())}`.replace(
    /[.,?/\\|<>]/g,
    ""
  );
  return sanitizedFileName;
};

// Shared status -> color mapping for the labels produced by EventList's
// getEventStatus(). Reused by the events table chips and the admin calendar
// so colors stay consistent across views.
export const getStatusColor = (statusLabel) => {
  switch (statusLabel) {
    case "Past - Not Paid":
      return "#f44336"; // red
    case "Done":
      return "#9e9e9e"; // grey
    case "Upcoming - Confirmed":
    case "In Progress":
      return "#4caf50"; // green
    case "Not Confirmed":
      return "#ff9800"; // orange
    case "Cancelled":
      return "#f44336"; // red
    default:
      return "#9e9e9e"; // grey fallback
  }
};

export const convertTo12HourFormat = (time) => {
  if (!time) return "";
  const [hour, minute] = time.split(":");
  const intHour = parseInt(hour, 10);
  const period = intHour >= 12 ? "pm" : "am";
  const formattedHour = intHour % 12 === 0 ? 12 : intHour % 12;
  return `${formattedHour}:${minute} ${period}`;
};
